/* eslint-disable react/jsx-filename-extension */
// @flow

import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export default function useRecaptcha() {
  const recaptchaRef = React.useRef();
  const executeRecaptcha = React.useCallback(async (): Promise<
    null | string,
  > => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      return recaptchaRef.current.executeAsync();
    }
    return null;
  }, []);

  if (!process.env.GATSBY_RECAPTCHA_SITEKEY) {
    return {
      element: null,
      execute: async () => null,
    };
  }

  return {
    element: (
      <ReCAPTCHA
        // $FlowFixMe --> Reason: recaptchaRef is not correctly typed
        ref={recaptchaRef}
        key="recaptcha"
        size="invisible"
        sitekey={process.env.GATSBY_RECAPTCHA_SITEKEY}
      />
    ),
    execute: executeRecaptcha,
  };
}
